<div class="flex flex-col w-full items-center justify-center h-full gap-y-10 relative">
  <img src="assets/mars.png" alt="" class="w-full fixed inset-0 m-auto z-0 mars top-[-750px]">
  <form
    class="bg-white border-color-2 border rounded-2xl shadow-lg flex flex-col justify-center mt-20 py-8 px-8 items-center z-10 w-[539px]"
    *ngIf="loginForm" [formGroup]="loginForm">
    <h4 class="text-color-1">Login</h4>
    <p class="text-color-3 mb-8">Enter your credentials to start the session</p>
    <div class="flex flex-col w-full gap-y-8">
      <div class="flex flex-col w-full ">
        <pickright-input label="Username" type="text" class="text-primary w-full " [required]="true"
          placeholder="username" formControlName="userName"></pickright-input>
      </div>
      <div class="flex flex-col w-full ">
        <pickright-input label="Password" type="text" [password]="true" class="text-primary w-full " [required]="true"
          formControlName="password" placeholder="password"></pickright-input>
      </div>
      <app-loader [loader]="isLoading" size="24px" class="w-full">
        <pickright-button type="fill" buttonType="submit" size="regular" text="Login" [disabled]="loginForm.invalid"
          (keyup.enter)="loginNow()" (btnClick)="loginNow()"></pickright-button>
      </app-loader>
    </div>
  </form>
</div>